import {Injectable} from '@angular/core';
import {RestService} from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class VerifierService {

  public static API_ENDPOINT = RestService.API_ENDPOINT + '/verify';

  constructor(private rest: RestService) {
  }
}
